import { Injectable } from "@angular/core";
import { ITicketSector, IXId } from "libraries/service/resources/booking/interfaces/IGetBookings";

@Injectable()
export class BookingTravellerTicketService {
    public getFareComponentSectorFilter(sectors: ITicketSector[], fareComponentSectors: IXId[]): ITicketSector[] {
        if (fareComponentSectors && fareComponentSectors.length) {
            return sectors.filter((sector: ITicketSector) => {
                return Boolean(fareComponentSectors.find(
                    (fareComponentSector: IXId): boolean => fareComponentSector.xRef === sector.xId)
                );
            });
        }

        return sectors;
    }
}
